export enum ProgressBarType {
  PRIMARY = "primary",
  SECONDARY = "secondary"
}

export enum ProgressBarStyle {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  POSITIVE = "positive",
  NEGATIVE = "negative",
  WARNING = "warning",
  NONE = "none"
}
